import { render, staticRenderFns } from "./BIDashboard.vue?vue&type=template&id=5f424a4e"
import script from "./BIDashboard.vue?vue&type=script&lang=js"
export * from "./BIDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports